function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState } from 'react';
import { Flex, Image } from '@tapresearch/ui/components';
import { OpacityTransitionBox } from '../../../../../shared/OpacityTransitionBox';
import { AnimatePresence } from 'framer-motion';
export function ImageTick(param) {
    var x = param.x, y = param.y, value = param.value, answersById = param.answersById;
    var _useState = _sliced_to_array(useState(false), 2), isHovering = _useState[0], setIsHovering = _useState[1];
    var size = 32;
    return /*#__PURE__*/ React.createElement("g", {
        transform: "translate(".concat(x - 21, ",").concat(y, ")")
    }, /*#__PURE__*/ React.createElement("foreignObject", {
        width: size,
        height: size,
        x: -11,
        y: -18,
        style: {
            overflow: 'visible'
        }
    }, /*#__PURE__*/ React.createElement(Flex, {
        zIndex: "10",
        justifyContent: "space-around",
        alignItems: "center",
        onMouseEnter: function() {
            return setIsHovering(true);
        },
        onMouseLeave: function() {
            return setIsHovering(false);
        },
        w: "100%",
        h: "100%",
        position: "relative",
        overflow: "visible"
    }, /*#__PURE__*/ React.createElement(Image, {
        w: "100%",
        src: answersById[value].image.url,
        alt: value
    }), /*#__PURE__*/ React.createElement(AnimatePresence, null, isHovering && /*#__PURE__*/ React.createElement(OpacityTransitionBox, {
        top: "44px",
        right: "0px",
        h: "180px",
        w: "180px",
        bgColor: "white",
        position: "absolute",
        duration: 1
    }, /*#__PURE__*/ React.createElement(Image, {
        w: "100%",
        src: answersById[value].image.url,
        alt: value
    }))))));
}
export function getImageTick(answersById) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return /*#__PURE__*/ React.createElement(ImageTick, _object_spread({
            answersById: answersById
        }, props));
    };
}
